import React from 'react'

import { Form, Col } from '_zari/core'

const FechaCreacionFormGroup = ({ onChange, value }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA CREACIÓN' htmlFor='date-fechaCreacion' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Form.InputDate id='date-fechaCreacion' name='date-fechaCreacion' onChange={onChange} value={value} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaCreacionFormGroup)
